<router-outlet></router-outlet>
<app-loader *ngIf="loaderService.showLoader"></app-loader>